import { SvgIconProps } from '@mui/material'
import { ReactComponent as ArrowRightSvg } from './arrow-right.svg'
import { ReactComponent as BorrowerIcon1Svg } from './borrower-icon-1.svg'
import { ReactComponent as BorrowerIcon2Svg } from './borrower-icon-2.svg'
import { ReactComponent as BorrowerIcon3Svg } from './borrower-icon-3.svg'
import { ReactComponent as DecentralizedSignalPortfolioSvg } from './decentralized-signal-portfolio.svg'
import { ReactComponent as DiscordSvg } from './discord.svg'
import { ReactComponent as EthereumSvg } from './ethereum.svg'
import { ReactComponent as EvaluationAgentsSvg } from './evaluation-agents.svg'
import { ReactComponent as FullCircleSvg } from './full-circle.svg'
import { ReactComponent as GithubSvg } from './github.svg'
import { ReactComponent as HumaFullLogoWhiteSvg } from './huma-full-white.svg'
import { ReactComponent as HumaFullLogoSvg } from './huma-full.svg'
import { ReactComponent as HumaWhiteSvg } from './huma-white.svg'
import { ReactComponent as HumaLogoSvg } from './huma.svg'
import { ReactComponent as InvestorIcon1Svg } from './investor-icon-1.svg'
import { ReactComponent as InvestorIcon2Svg } from './investor-icon-2.svg'
import { ReactComponent as InvestorIcon3Svg } from './investor-icon-3.svg'
import { ReactComponent as JoinTheCommunityDiscordSvg } from './jointhecommunity-discord.svg'
import { ReactComponent as JoinTheCommunityLinkedInSvg } from './jointhecommunity-linkedin.svg'
import { ReactComponent as JoinTheCommunityTelegramSvg } from './jointhecommunity-telegram.svg'
import { ReactComponent as JoinTheCommunityXSvg } from './jointhecommunity-x.svg'
import { ReactComponent as JoinTheCommunityYoutubeSvg } from './jointhecommunity-youtube.svg'
import { ReactComponent as LendingPoolsSvg } from './lending-pools.svg'
import { ReactComponent as LinkedinSvg } from './linkedin.svg'
import { ReactComponent as MirrorSvg } from './mirror.svg'
import { ReactComponent as PartnerWithCompliantIconSvg } from './partner-with-compliant.svg'
import { ReactComponent as PartnerWithCreditIconSvg } from './partner-with-credit.svg'
import { ReactComponent as PartnerWithGlobalIconSvg } from './partner-with-global.svg'
import { ReactComponent as PartnerWithGrowIconSvg } from './partner-with-grow.svg'
import { ReactComponent as PartnerWithPerformIconSvg } from './partner-with-perform.svg'
import { ReactComponent as PartnerWithSafeIconSvg } from './partner-with-safe.svg'
import { ReactComponent as ReceivablesSvg } from './receivables.svg'
import { ReactComponent as SocialMediaXSvg } from './socialmedia-x.svg'
import { ReactComponent as SolanaLogoSvg } from './solanaLogoMark.svg'
import { ReactComponent as StellarLogoSvg } from './stellar-xlm-logo.svg'
import { ReactComponent as TelegramSvg } from './telegram.svg'
import { ReactComponent as TwitterSvg } from './twitter.svg'
import { ReactComponent as YoutubeSvg } from './youtube.svg'

export function HumaIcon(props: SvgIconProps): React.ReactElement {
  return <HumaLogoSvg {...props} />
}

export function HumaFullIcon(props: SvgIconProps): React.ReactElement {
  return <HumaFullLogoSvg {...props} />
}

export function HumaFullLogoWhite(props: SvgIconProps): React.ReactElement {
  return <HumaFullLogoWhiteSvg {...props} />
}

export function HumaWhiteIcon(props: SvgIconProps): React.ReactElement {
  return <HumaWhiteSvg {...props} />
}

export function TwitterIcon(props: SvgIconProps): React.ReactElement {
  return <TwitterSvg {...props} />
}

export function LinkedinIcon(props: SvgIconProps): React.ReactElement {
  return <LinkedinSvg {...props} />
}

export function GithubIcon(props: SvgIconProps): React.ReactElement {
  return <GithubSvg {...props} />
}

export function YoutubeIcon(props: SvgIconProps): React.ReactElement {
  return <YoutubeSvg {...props} />
}

export function MirrorIcon(props: SvgIconProps): React.ReactElement {
  return <MirrorSvg {...props} />
}

export function TelegramIcon(props: SvgIconProps): React.ReactElement {
  return <TelegramSvg {...props} />
}

export function DiscordIcon(props: SvgIconProps): React.ReactElement {
  return <DiscordSvg {...props} />
}

export function ReceivablesIcon(props: SvgIconProps): React.ReactElement {
  return <ReceivablesSvg {...props} />
}

export function LendingPoolsIcon(props: SvgIconProps): React.ReactElement {
  return <LendingPoolsSvg {...props} />
}

export function DecentralizedSignalPortfolioIcon(
  props: SvgIconProps,
): React.ReactElement {
  return <DecentralizedSignalPortfolioSvg {...props} />
}

export function EvaluationAgentsIcon(props: SvgIconProps): React.ReactElement {
  return <EvaluationAgentsSvg {...props} />
}

export function ArrowRightIcon(props: SvgIconProps): React.ReactElement {
  return <ArrowRightSvg {...props} />
}

export function FullCircleIcon(props: SvgIconProps): React.ReactElement {
  return <FullCircleSvg {...props} />
}

export function PartnerWithGlobalIcon(props: SvgIconProps): React.ReactElement {
  return <PartnerWithGlobalIconSvg {...props} />
}

export function PartnerWithCreditIcon(props: SvgIconProps): React.ReactElement {
  return <PartnerWithCreditIconSvg {...props} />
}

export function PartnerWithGrowIcon(props: SvgIconProps): React.ReactElement {
  return <PartnerWithGrowIconSvg {...props} />
}

export function PartnerWithPerformIcon(
  props: SvgIconProps,
): React.ReactElement {
  return <PartnerWithPerformIconSvg {...props} />
}

export function PartnerWithSafeIcon(props: SvgIconProps): React.ReactElement {
  return <PartnerWithSafeIconSvg {...props} />
}

export function PartnerWithCompliantIcon(
  props: SvgIconProps,
): React.ReactElement {
  return <PartnerWithCompliantIconSvg {...props} />
}

export function BorrowerIcon1(props: SvgIconProps): React.ReactElement {
  return <BorrowerIcon1Svg {...props} />
}

export function BorrowerIcon2(props: SvgIconProps): React.ReactElement {
  return <BorrowerIcon2Svg {...props} />
}

export function BorrowerIcon3(props: SvgIconProps): React.ReactElement {
  return <BorrowerIcon3Svg {...props} />
}

export function InvestorIcon1(props: SvgIconProps): React.ReactElement {
  return <InvestorIcon1Svg {...props} />
}

export function InvestorIcon2(props: SvgIconProps): React.ReactElement {
  return <InvestorIcon2Svg {...props} />
}

export function InvestorIcon3(props: SvgIconProps): React.ReactElement {
  return <InvestorIcon3Svg {...props} />
}

export function JoinTheCommunityX(props: SvgIconProps): React.ReactElement {
  return <JoinTheCommunityXSvg {...props} />
}

export function JoinTheCommunityTelegram(
  props: SvgIconProps,
): React.ReactElement {
  return <JoinTheCommunityTelegramSvg {...props} />
}

export function JoinTheCommunityDiscord(
  props: SvgIconProps,
): React.ReactElement {
  return <JoinTheCommunityDiscordSvg {...props} />
}

export function JoinTheCommunityLinkedIn(
  props: SvgIconProps,
): React.ReactElement {
  return <JoinTheCommunityLinkedInSvg {...props} />
}

export function JoinTheCommunityYoutube(
  props: SvgIconProps,
): React.ReactElement {
  return <JoinTheCommunityYoutubeSvg {...props} />
}

export function SocialMediaX(props: SvgIconProps): React.ReactElement {
  return <SocialMediaXSvg {...props} />
}

export function EthereumIcon(props: SvgIconProps): React.ReactElement {
  return <EthereumSvg {...props} />
}

export function SolanaLogoIcon(props: SvgIconProps): React.ReactElement {
  return <SolanaLogoSvg {...props} />
}

export function StellarLogoIcon(props: SvgIconProps): React.ReactElement {
  return <StellarLogoSvg {...props} />
}
